const _ = require('lodash');

const replaceInlistIfExists = (newList, oldList, mergeOnProperty = 'id') => {
  _.each(newList, element => {
    const index = _.findIndex(oldList, {
      [mergeOnProperty]: element[mergeOnProperty],
    });
    if (index >= 0) {
      oldList.splice(index, 1, element);
    }
  });
  return oldList;
};

const arrayMerge = (newList, oldList, mergeOnProperty = 'id') => {
  if (!newList || !oldList) throw new Error('Array is null error');
  const bIndexed = {};

  _.each(oldList, x => {
    bIndexed[x[mergeOnProperty]] = x;
  });
  const result = newList.map(item => {
    const existing = bIndexed[item.id];
    if (!existing) {
      return item;
    }
    delete bIndexed[item.id];
    return { ...existing, ...item };
  });
  return Object.values(bIndexed).concat(result);
};

const queryFunctions = {
  eq: (a, b) => a === b,
  lt: (a, b) => a < b,
  gt: (a, b) => a > b,
  iLike: (a, b) => {
    // TODO not completed
    if (b.charAt(0) === '%' && b.slice(-1) === '%') {
      const search = b.substring(1, b.length - 1);
      return a.toLowerCase().includes(search.toLowerCase());
    }
    throw new Error('not yet supported');
  },
};

/*
 * q = { a: 3, b: {lt: 4}, c: {lt: 4, gt: 2 } }
 * e.g test = { a: 3, b: 3 }
 */
const match = (q = {}) => {
  const query = {};
  Object.entries(q).forEach(([key, value]) => {
    query[key] =
      typeof value === 'object' ? value : (query[key] = { eq: value });
  });

  return test => {
    let result = true;
    Object.entries(query).forEach(([fieldToMatch, toMatch]) => {
      Object.entries(toMatch).forEach(([testFunction, rightHand]) => {
        result =
          result &&
          (queryFunctions[testFunction](test[fieldToMatch], rightHand) ||
            (test[fieldToMatch] &&
              test[fieldToMatch].id &&
              queryFunctions[testFunction](test[fieldToMatch].id, rightHand)));
      });
    });
    return !!result;
  };
};

module.exports = { match, arrayMerge, replaceInlistIfExists };
